import React from 'react';
import { PluginGarden } from './PluginGarden';

export const HeroSection1 = ({ pluginGardenRef }) => {
    return (
        <section
            className="md:min-h-screen md:h-screen w-full bg-[#f8f9fa] dark:bg-[#161616] grid-pattern relative overflow-hidden pt-0 md:pt-20"
            data-testid="hero-section-1"
        >
            {/* Mobile Layout (≤768px) */}
            <div className="md:hidden flex flex-col items-center justify-start px-6 pt-40 pb-16 text-center">
                <h1
                    className="text-[36px] font-extrabold text-[#1a1a1a] dark:text-white leading-[1.3] tracking-tight mb-6"
                    style={{
                        fontFamily: "'Martel Sans', sans-serif"
                    }}
                >
                    Your AI builder gave up?
                    <span className="text-[#7cb687] block mt-3">We didn't.</span>
                </h1>

                <p
                    className="text-lg text-[#4a4a4a] dark:text-[#e0e0e0] font-normal px-4"
                    style={{
                        fontFamily: "'Martel Sans', sans-serif"
                    }}
                >
                    Production-ready AI MCPs for payments, backend, and infra
                </p>
            </div>

            {/* Desktop Layout (>768px) */}
            <div className="hidden md:flex max-w-[1400px] mx-auto h-full px-6 lg:px-20 items-center">
                <div className="basis-[58%] h-full flex flex-col justify-center pr-10 lg:pr-16">
                    <div className="diagonal-text space-y-8 w-full">
                        <h1
                            className="text-5xl lg:text-6xl xl:text-7xl 2xl:text-7xl font-black text-[#1a1a1a] dark:text-white leading-[1.3] tracking-tight"
                            style={{
                                opacity: 1,
                                animation: 'fade-in-up 0.8s ease forwards',
                                animationDelay: '0.2s',
                                fontFamily: "'Martel Sans', sans-serif"
                            }}
                        >
                            Your AI builder gave up?
                            <span className="text-[#9be38f] block mt-4">We didn't.</span>
                        </h1>

                        <p
                            className="text-xl lg:text-2xl text-[#1a1a1a]/80 dark:text-white/80 font-medium pl-2 leading-snug"
                            style={{
                                opacity: 0,
                                animation: 'fade-in-up 0.8s ease forwards',
                                animationDelay: '0.4s',
                                fontFamily: "'Martel Sans', sans-serif"
                            }}
                        >
                            Production-ready AI MCPs for payments, backend, and infra.
                        </p>
                    </div>
                </div>

                {/* Right side - Plugin garden */}
                <div className="basis-[42%] h-full relative">
                    <PluginGarden ref={pluginGardenRef} activePluginIndex={3} />
                </div>
            </div>

            {/* Background floating particles - hidden on mobile */}
            <div className="absolute inset-0 pointer-events-none hidden md:block">
                {[...Array(25)].map((_, i) => (
                    <div
                        key={i}
                        className="absolute w-1 h-1 rounded-full bg-[#9be38f] opacity-20"
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                            animation: `particle-drift ${8 + Math.random() * 4}s linear infinite`,
                            animationDelay: `${Math.random() * 5}s`
                        }}
                    />
                ))}
            </div>

            {/* Scroll indicator - hidden on mobile */}
            <div
                className="absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-2 text-[#1a1a1a]/40 dark:text-white/40 hidden md:flex"
                style={{ animation: 'float 2s ease-in-out infinite' }}
            >
                <span className="text-sm">Scroll to pluck</span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 5v14M19 12l-7 7-7-7" />
                </svg>
            </div>
        </section>
    );
};

export default HeroSection1;

